import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/scripts/pdf.worker.min.mjs`;

export const PdfViewer = ({
  fileUrl,
  numPages,
  setNumPages,
  zoomed = false,
  width,
}: {
  fileUrl: string;
  numPages: number;
  setNumPages: (n: number) => void;
  zoomed?: boolean;
  width?: number;
}) => {
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  return (
    <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
      {zoomed ? (
        Array.from(new Array(numPages), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        ))
      ) : (
        <Page
          pageNumber={1}
          width={width}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      )}
    </Document>
  );
};
